import gql from "graphql-tag";

export default gql`
  mutation deleteCertificate($serial: String!) {
    deleteCertificate(serial: $serial)
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutation/DeleteCertificate.js